import { useEffect } from '@wordpress/element';

export const useLocalStorage = (key, value, setValue, defaultValue) => {
  useEffect(() => {
    try {
      const savedValue = localStorage.getItem(key);
      if (savedValue !== null) {
        // Try to parse JSON
        try {
          setValue(JSON.parse(savedValue));
        } catch (err) {
          // If not JSON, store raw string
          setValue(savedValue);
        }
      } else if (defaultValue !== undefined) {
        setValue(defaultValue);
      }
    } catch (err) {
     // console.error(`Error reading localStorage key “${key}”:`, err);
    }
  }, [key, setValue, defaultValue]);

  useEffect(() => {
    try {
      if (typeof value === 'string') {
        localStorage.setItem(key, value);
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (err) {
     // console.error(`Error setting localStorage key “${key}”:`, err);
    }
  }, [key, value]);
};

export default useLocalStorage;
